<template>
  <div class="content">
    <div class="panel">
      <div class="btn-container u-pull-right">
        <back-button></back-button>
      </div>
      <h1 class="font-light">Change Signature</h1>
      <div class="divider u-no-margin"></div>
      <div class="panel">
        To change your <strong>signature</strong> please enter your
        <i>current</i> password, then enter your <i>new signature twice</i>
        <br />
        If you don't know your current password then you can
        <router-link style="display: inline" :to="{ name: 'reset-password' }">
          click here</router-link
        >
        to reset it.
      </div>
      <div class="form-section">
        <!-- Password -->
        <div class="row level">
          <div class="offset-2 col-10 error" v-if="error.password">
            {{ error.password }}
          </div>
          <div class="col-2 level-item font-bold">
            <span class="u-fill-width">
              Password:
            </span>
          </div>
          <div class="col-10 level-item input-control">
            <input
              v-model="formData.password"
              v-bind:class="{ 'input-error': error.password }"
              type="password"
              placeholder="Super Secret Password"
              class="input-contains-icon"
            />
            <span class="icon">
              <i class="fa fa-wrapper fa-key"></i>
            </span>
          </div>
        </div>
        <!-- New signature -->
        <div class="row level">
          <div class="offset-2 col-10 error" v-if="error.new_signature">
            {{ error.new_signature }}
          </div>
          <div class="col-2 level-item font-bold">
            <span class="u-fill-width">
              Signature Code:
            </span>
          </div>
          <div class="col-10 level-item input-control">
            <input
              class="input-contains-icon"
              type="password"
              placeholder="Enter your new signature"
              v-bind:class="{ 'input-error': error.new_signature }"
              v-model="formData.new_signature"
            />
            <span class="icon">
              <i class="fa fa-wrapper fa-fingerprint"></i>
            </span>
          </div>
        </div>
        <!-- Check new signature -->
        <div class="row level">
          <div class="offset-2 col-10 error" v-if="error.check_signature">
            {{ error.check_signature }}
          </div>
          <div class="col-2 level-item font-bold">
            <span class="u-fill-width">Confirm Code:</span>
          </div>
          <div class="col-10 level-item input-control">
            <input
              class="input-contains-icon"
              type="password"
              placeholder="Confirm signature"
              v-bind:class="{ 'input-error': error.check_signature }"
              v-model="formData.check_signature"
            />
            <span class="icon">
              <i class="fa fa-wrapper fa-fingerprint"></i>
            </span>
          </div>
        </div>
        <space></space>
        <div class="row">
          <div class="u-text-right u-fill-width">
            <button
              class="btn-primary u-pull-right --tas-button-side-margin"
              v-on:click="changeSignature"
              value="Login"
              type="submit"
            >
              <loading-spinner v-show="submit"></loading-spinner>
              <i
                class="fa-wrapper fa fa-paper-plane pad-right"
                v-show="!submit"
              ></i>
              Change Signature
            </button>
          </div>
        </div>
      </div>
      <toast-success
        v-if="success"
        v-bind:label="'Signature Updated'"
        v-bind:message="'Your signature has been successfully updated.'"
        v-on:close="closeSuccess"
      >
      </toast-success>
      <server-error v-bind:error="error.serverError"></server-error>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ServerError from "@/components/ServerError";
import BackButton from "@/components/BackButton";
import LoadingSpinner from "@/components/LoadingSpinner";
import ToastSuccess from "@/components/ToastSuccess";
import * as authService from "@/services/auth.service";
import { handleError } from "@/functions/handleError.function";

export default {
  name: "change-password",
  components: {
    ServerError,
    BackButton,
    LoadingSpinner,
    ToastSuccess
  },
  data: function() {
    return {
      formData: {
        password: undefined,
        new_signature: undefined,
        check_signature: undefined
      },
      success: false,
      submit: false
    };
  },
  computed: {
    ...mapGetters("core", ["error"])
  },
  methods: {
    validate_form: function() {
      var valid = true;
      if (!this.formData.password) {
        this.$store.commit("core/setError", {
          password: "You must enter your current password."
        });
        valid = false;
      }
      if (!this.formData.new_signature) {
        this.$store.commit("core/setError", {
          new_signature: "You must enter a new signature."
        });
        valid = false;
      }
      if (this.formData.new_signature != this.formData.check_signature) {
        this.$store.commit("core/setError", {
          check_signature:
            "This doesn't match your new signature. Check your spelling?"
        });
        valid = false;
      }
      return valid;
    },
    changeSignature: function() {
      this.$store.commit("core/clearErrors");
      this.submit = true;
      if (this.validate_form() == false) {
        this.submit = false;
        return; // Break if not valid
      }
      authService
        .setSignature(this.formData)
        .then(result => {
          if (result.status == 204) {
            // Success! (but no content!)
            this.submit = false;
            this.success = true;
            // Update the userProfile as the has_signature value may have
            // changed
            this.$store.dispatch("auth/getUserProfile");
          }
        })
        .catch(error => {
          this.submit = false;
          this.success = false;
          let data = handleError(error);
          this.$store.commit("core/setError", data);
        });
    },
    closeSuccess: function() {
      this.success = false;
    }
  },
  mounted() {
    this.$store.commit("core/clearErrors");
  }
};
</script>
